// Gift card must start with GC, GM or KG (highlandbase) and have 9 digits after
const giftCardRegex = /^(GC|GM|KGC)[0-9]{9}$/

export const isValidGiftCard = (giftCard: string) => {
  return giftCardRegex.test(giftCard)
}
